if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat([
          'data-trigger-open',
          'data-repeat-open',
          'data-delay-seconds',
          'data-pageview-count',
        ]);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen;
        this.repeatOpen = this.dataset.repeatOpen;
        this.delayMs = (Number(this.dataset.delaySeconds) || 5) * 1000;
        this.pageviewCount = Number(this.dataset.pageviewCount) || 0;
        this.cookieName = 'hypertheme:popup';
        this.pageviewKey = 'hypertheme:popup:pageviews';

        window.FoxTheme.DOMready(this.handleOpen.bind(this));
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;

        let savedData = FoxTheme.utils.getStorage(this.cookieName);
        if (savedData && savedData.opened) {
          return false;
        }

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, this.delayMs);
            break;
          case 'delay_or_pageviews':
            // Whichever comes first: enough pages seen this visit, or enough
            // time spent on this one.
            if (this.pageviewCount > 0 && this.countPageview() >= this.pageviewCount) {
              this.show();
              break;
            }
            setTimeout(() => {
              this.show();
            }, this.delayMs);
            break;
          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;
          case 'exit_intent':
            this.watchForExit();
            break;
          default:
            this.show();
            break;
        }
      }

      /* Fires when the pointer crosses the top edge of the window - the move
         towards the address bar or the tab strip. relatedTarget is null only
         when the pointer has left the document entirely, which is what
         separates a real exit from moving between two elements, and clientY <= 0
         keeps it to the top edge rather than any edge.

         A touch device has no equivalent signal. Rather than invent one from
         scroll direction, which fires on ordinary reading, those visitors get
         the delay instead. */
      watchForExit() {
        const canHover = window.matchMedia('(hover: hover)').matches;
        if (!canHover) {
          setTimeout(() => {
            this.show();
          }, this.delayMs);
          return;
        }

        const onLeave = (event) => {
          if (event.relatedTarget || event.clientY > 0) return;
          document.removeEventListener('mouseout', onLeave);
          this.show();
        };
        document.addEventListener('mouseout', onLeave);
      }

      // Pages viewed this visit. sessionStorage, so a new visit starts over;
      // storage can throw in private mode, hence the guard.
      countPageview() {
        try {
          const next = Number(sessionStorage.getItem(this.pageviewKey) || 0) + 1;
          sessionStorage.setItem(this.pageviewKey, String(next));
          return next;
        } catch (e) {
          return 0;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;
        window.addEventListener('scroll', (e) => {
          let scrollTop =
            window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

          if (scrollTop - start > offset && !opened) {
            trigger();
            opened = true;
            return;
          }
        });
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;
        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;
          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;
          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;
          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;
          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;
          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;
          case 'every_1_hr':
            expires = 1 / 24;
            break;
          case 'every_6_hrs':
            expires = 6 / 24;
            break;
          case 'every_12_hrs':
            expires = 1 / 2;
            break;
          case 'every_day':
            expires = 1;
            break;
          case 'every_3_days':
            expires = 3;
            break;
          case 'every_week':
            expires = 7;
            break;
          case 'every_2_weeks':
            expires = 14;
            break;
          case 'every_month':
            expires = 30;
            break;
          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}
